import { getCurrentTabId } from '../../../util/establishMultitabRole';
import {
  parseMiniAppAccountId,
  clearMiniAppAccountId,
  getTelegramMiniAppInitData,
  notifyTelegramMiniAppReady,
  requestTelegramMiniAppFullscreen,
  setIsMiniAppAuthPending,
  takePendingMiniAppAuth,
} from '../../../util/miniApp';
import { fetchMiniAppAuthToken } from '../../../api/miniApp';
import {
  addActionHandler, getGlobal, setGlobal,
} from '../../index';

addActionHandler('fetchMiniAppToken', async (global, actions): Promise<void> => {
  console.log('[fetchMiniAppToken] START');

  const accountId = parseMiniAppAccountId();
  console.log('[fetchMiniAppToken] accountId:', accountId);

  // Токен, перенесённый с предыдущей страницы при переезде на свободный слот
  const carriedAuth = takePendingMiniAppAuth();
  if (carriedAuth) {
    console.log('[fetchMiniAppToken] Reusing token carried over from previous slot');
    setGlobal({
      ...getGlobal(),
      auth: {
        ...getGlobal().auth,
        isFetchingMiniAppToken: true,
        pendingMiniAppToken: carriedAuth.token,
        pendingMiniAppDcId: carriedAuth.dcId,
        pendingMiniAppUserId: carriedAuth.userId,
      },
    });

    notifyTelegramMiniAppReady();
    requestTelegramMiniAppFullscreen();
    setIsMiniAppAuthPending(false);
    actions.initApi();
    return;
  }

  const initData = getTelegramMiniAppInitData();
  console.log('[fetchMiniAppToken] initData:', initData ? 'present' : 'missing');
  console.log('[fetchMiniAppToken] Telegram.WebApp:', typeof (window as any).Telegram?.WebApp);

  // Не Mini App сценарий - продолжить обычный флоу
  if (!accountId || !initData) {
    console.log('[fetchMiniAppToken] Fallback to regular auth (no accountId or initData)');
    setIsMiniAppAuthPending(false);
    actions.initApi();
    return;
  }

  // Показать экран загрузки Mini App
  setGlobal({
    ...getGlobal(),
    auth: {
      ...getGlobal().auth,
      isFetchingMiniAppToken: true,
    },
  });

  console.log('[fetchMiniAppToken] Fetching token for accountId:', accountId);

  const backendUrl = import.meta.env.TG_MINI_APP_BACKEND_URL;
  if (!backendUrl) {
    console.error('[fetchMiniAppToken] MINI_APP_BACKEND_URL not configured');
    setGlobal({
      ...getGlobal(),
      auth: {
        ...getGlobal().auth,
        isFetchingMiniAppToken: false,
      },
    });
    actions.showNotification({
      message: { key: 'MiniAppConfigError' },
      tabId: getCurrentTabId(),
    });
    setIsMiniAppAuthPending(false);
    actions.initApi();
    return;
  }

  // Намеренно напрямую, а не через `callApi`: воркер gramjs поднимает `initApi`,
  // который до получения токена заблокирован, а `callApi` до инициализации воркера
  // складывает вызовы в очередь - получался дедлок с зависанием на "Authorizing".
  // Это обычный fetch, gramjs ему не нужен
  const result = await fetchMiniAppAuthToken({
    accountId,
    initData,
    backendUrl,
  });

  if (!result) {
    console.error('[fetchMiniAppToken] Failed to fetch token');
    setGlobal({
      ...getGlobal(),
      auth: {
        ...getGlobal().auth,
        isFetchingMiniAppToken: false,
      },
    });
    actions.showNotification({
      message: { key: 'MiniAppAuthError' },
      tabId: getCurrentTabId(),
    });
    setIsMiniAppAuthPending(false);
    actions.initApi();
    return;
  }

  console.log('[fetchMiniAppToken] Token received, userId:', result.userId);

  // Сохранить токен в global state
  // НЕ сбрасываем isFetchingMiniAppToken здесь - он сбросится в apiUpdater когда авторизация завершится
  setGlobal({
    ...getGlobal(),
    auth: {
      ...getGlobal().auth,
      pendingMiniAppToken: result.token,
      pendingMiniAppDcId: result.dcId,
      pendingMiniAppUserId: result.userId,
    },
  });

  // НЕ очищаем accountId - он нужен для сохранения hash при редиректах!
  // clearMiniAppAccountId();

  // Уведомить Telegram о готовности
  notifyTelegramMiniAppReady();
  requestTelegramMiniAppFullscreen();

  // Продолжить инициализацию с токеном
  setIsMiniAppAuthPending(false);
  actions.initApi();
});
